import frenchLocaleSpecificationForDateFns from 'date-fns/locale/fr';
import { LocaleSettings as DatesLocaleSettings } from '@bimone/bimtrack-dates';
import { I18n, Language, LocaleSettingsClient } from '@bimone/bimtrack-core';
import { LocaleSettings as ComponentLibraryLocalSettings } from '@bimone/bimtrackreactcomponents';

export default class LocaleSettings implements LocaleSettingsClient {
  public constructor(private readonly i18n?: I18n) {}

  public setupLocaleSpecifications(): void {
    ComponentLibraryLocalSettings.setupLocale(Language.FR, null, frenchLocaleSpecificationForDateFns);
    DatesLocaleSettings.setupLocaleSpecifications();
  }

  public getCurrentTimeZone(): string {
    return DatesLocaleSettings.getCurrentTimeZone();
  }

  public getWellKnownTimeZoneFrom(timezone: string): string {
    return DatesLocaleSettings.getWellKnownTimeZoneFrom(timezone);
  }

  public setCurrentTimeZone(timeZone?: string): void {
    DatesLocaleSettings.setCurrentTimeZone(timeZone);
  }

  public getCurrentLocale(): string {
    return this.i18n?.language ?? DatesLocaleSettings.getCurrentLocale();
  }

  public setCurrentLocale(language: Language): void {
    this.i18n?.changeLanguage(language);
    ComponentLibraryLocalSettings.setLocale(language);
    DatesLocaleSettings.setCurrentLocale(language);
  }
}
